export default __webpack_public_path__ + "static/media/x.682e6e86.png";